<script lang="ts">
	//UI
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	//Utils
	import { api } from "@hitit/hub/src/stores";
	import { selectedUser } from "../../stores";
	import { onDestroy } from "svelte";
	//Types
	//Props
	export let userId = "";
	//Constants
	//Variables
	let error = false;
	let loading = true;
	//Functions
	//Do
	$: (async (originUserId: string) => {
		try {
			loading = true;
			const response = await $api.getUser(userId);

			if (userId !== originUserId) return;
			$selectedUser = response.data;
			error = false;
		} catch (e) {
			if (userId !== originUserId) return;
			error = true;
			$selectedUser = undefined;
		} finally {
			if (userId !== originUserId) return;
			loading = false;
		}
	})(userId);

	onDestroy(() => ($selectedUser = undefined));

</script>

{#if loading}
	<ContainerLoading />
{/if}
<slot />

<style lang="scss">
</style>
